<template>
  <div>
    <div class="resume-table disp-scroll" v-if="ocrInputDataLeft && ocrInputDataRight">
      <!-- <div style="width: 350px; height: 200px; overflow: scroll; padding: 8px; border: solid 3px black; text-align: left;">
            {{ocrInputDataLeft}} - {{ocrInputDataRight}}
      </div> -->
      <div style="padding: 16px;" v-if="rirekisyoStepNew===0">
        <h2 style="padding: 8px; font-size: larger;"><b>基本情報</b></h2>
        <p class="input-box" style="border-top: solid thin #ccc;">
          <span class="input-label">名前（ふりがな）</span>
          <input class="input input-modal" v-model="ocrInputDataLeft.name_furigana"/>
        </p>
        <p class="input-box">
          <span class="input-label">名前</span>
          <input class="input input-modal" v-model="ocrInputDataLeft.name"/>
        </p>
        <p class="input-box">
          <span class="input-label">性別</span>
          <input class="input input-modal" v-model="ocrInputDataLeft.sex"/>
        </p>
        <p class="input-box">
          <span class="input-label">誕生日</span>
          <input class="input input-modal" v-model="ocrInputDataLeft.birthday"/>
        </p>
        <p class="input-box">
          <span class="input-label">住所（ふりがな）</span>
          <input class="input input-modal" v-model="ocrInputDataLeft.addr_furigana"/>
        </p>
        <p class="input-box">
          <span class="input-label">住所</span>
          <input class="input input-modal" v-model="ocrInputDataLeft.addr"/>
        </p>
        <p class="input-box">
          <span class="input-label">TEL</span>
          <input class="input input-modal" v-model="ocrInputDataLeft.tel"/>
        </p>
        <p class="input-box">
          <span class="input-label">Email</span>
          <input class="input input-modal" v-model="ocrInputDataLeft.email"/>
        </p>
      </div>
      <div style="padding: 16px;" v-if="rirekisyoStepNew===1">
        <h2 style="padding: 8px; font-size: larger;"><b>経歴</b></h2>
        <table class="table-box">
          <tr>
            <th class="table-box-header" style="width: 120px;">年</th>
            <th class="table-box-header" style="width: 50px;">月</th>
            <th class="table-box-header">学歴・職歴</th>
          </tr>
          <tr v-for="(r, idx) in ocrInputDataLeft.reki_nen" :key="idx" v-if="ocrInputDataLeft.reki_nen[idx] != ''||ocrInputDataLeft.reki_tsuki[idx] != ''||ocrInputDataLeft.reki[idx] != ''">
            <td>
              <input class="input input-table" style="width: 120px;" v-model="ocrInputDataLeft.reki_nen[idx]"/>
            </td>
            <td>
              <input class="input input-table" style="width: 50px;" v-model="ocrInputDataLeft.reki_tsuki[idx]"/>
            </td>
            <td>
              <input class="input input-table" v-model="ocrInputDataLeft.reki[idx]"/>
            </td>
          </tr>
          <tr v-for="(r, idx2) in keirekiTable" :key="idx2" v-if="keirekiTable.length > 0">
            <td>
              <input placeholder="2019" class="input input-table" style="width: 120px;" v-model="keirekiTable[idx2].keireki_nen"/>
            </td>
            <td>
              <input placeholder="3" class="input input-table" style="width: 50px;" v-model="keirekiTable[idx2].keireki_tsuki"/>
            </td>
            <td>
              <input placeholder="○○株式会社 入社" class="input input-table" v-model="keirekiTable[idx2].keireki"/>
            </td>
          </tr>
        </table>
        <button @click="keirekiTable.push(JSON.parse(JSON.stringify(keirekiData)))" class="button is-primary is-fullwidth" style="border-radius: 0;" v-if="keirekiTable.length<9">＋ 追加する</button>
      </div>
      <div v-if="rirekisyoStepNew===2">
        <h2 style="padding: 8px; font-size: larger;"><b>経歴 ②</b></h2>
        <table class="table-box">
          <tr>
            <th class="table-box-header" style="width: 120px;">年</th>
            <th class="table-box-header" style="width: 50px;">月</th>
            <th class="table-box-header">学歴・職歴</th>
          </tr>
          <tr v-for="(r, idx) in ocrInputDataRight.reki_nen" :key="idx" v-if="ocrInputDataRight.reki_nen[0]!=''&&ocrInputDataRight.reki_nen[1]!=''&&ocrInputDataRight.reki_nen[2]!=''&&ocrInputDataRight.reki_nen[3]!=''">
            <td>
              <input class="input input-table" style="width: 120px;" v-model="ocrInputDataRight.reki_nen[idx]"/>
            </td>
            <td>
              <input class="input input-table" style="width: 50px;" v-model="ocrInputDataRight.reki_tsuki[idx]"/>
            </td>
            <td>
              <input class="input input-table" v-model="ocrInputDataRight.reki[idx]"/>
            </td>
          </tr>
          <tr v-for="(r, idx2) in keirekiTable2" :key="idx2" v-if="keirekiTable2.length > 0">
            <td>
              <input placeholder="2019" class="input input-table" style="width: 120px;" v-model="keirekiTable2[idx2].keireki_nen"/>
            </td>
            <td>
              <input placeholder="3" class="input input-table" style="width: 50px;" v-model="keirekiTable2[idx2].keireki_tsuki"/>
            </td>
            <td>
              <input placeholder="○○株式会社 入社" class="input input-table" v-model="keirekiTable2[idx2].keireki"/>
            </td>
          </tr>
        </table>
        <button @click="keirekiTable2.push(JSON.parse(JSON.stringify(keirekiData)))" class="button is-primary is-fullwidth" style="border-radius: 0;" v-if="keirekiTable2.length<9">＋ 追加する</button>
      </div>
      <div style="padding: 16px;" v-if="rirekisyoStepNew===3">
        <h2 style="padding: 8px; font-size: larger;"><b>資格</b></h2>
        <table class="table-box">
          <tr>
            <th class="table-box-header" style="width: 120px;">年</th>
            <th class="table-box-header" style="width: 50px;">月</th>
            <th class="table-box-header">免許・資格</th>
          </tr>
          <tr v-for="(r, idx) in ocrInputDataRight.shikaku_nen" :key="idx" v-if="ocrInputDataRight.shikaku_nen">
            <td>
              <input class="input input-table" style="width: 120px;" v-model="ocrInputDataRight.shikaku_nen[idx]"/>
            </td>
            <td>
              <input class="input input-table" style="width: 50px;" v-model="ocrInputDataRight.shikaku_tsuki[idx]"/>
            </td>
            <td>
              <input class="input input-table" v-model="ocrInputDataRight.shikaku[idx]"/>
            </td>
          </tr>
          <tr v-for="(r, idx2) in shikakuTable" :key="idx2" v-if="shikakuTable.length > 0">
            <td>
              <input placeholder="2019" class="input input-table" style="width: 120px;" v-model="shikakuTable[idx2].shikaku_nen"/>
            </td>
            <td>
              <input placeholder="3" class="input input-table" style="width: 50px;" v-model="shikakuTable[idx2].shikaku_tsuki"/>
            </td>
            <td>
              <input placeholder="普通自動車免許 取得" class="input input-table" v-model="shikakuTable[idx2].shikaku"/>
            </td>
          </tr>
        </table>
        <button @click="shikakuTable.push(JSON.parse(JSON.stringify(shikakuData)))" class="button is-primary is-fullwidth" style="border-radius: 0;" v-if="shikakuTable.length<8">＋ 追加する</button>
      </div>
      <div style="padding: 16px;" v-if="rirekisyoStepNew===4">
        <h2 style="padding: 8px; font-size: larger;"><b>詳細情報</b></h2>
        <p class="input-box" style="border-top: solid thin #ccc;">
          <span class="input-label">志望動機 / 自己PR / <br>趣味特技など</span>
          <textarea class="textarea input-modal disp-scroll" style="min-width: calc(100% - 30%); max-width: calc(100% - 30%); resize: none;" v-model="ocrInputDataRight.shibo_doki"/>
        </p>
        <p class="input-box">
          <span class="input-label">通勤時間</span>
          <input class="input input-modal" v-model="ocrInputDataRight.tsukin_jikan"/>
        </p>
        <p class="input-box">
          <span class="input-label">最寄駅</span>
          <input class="input input-modal" v-model="ocrInputDataRight.moyori_eki"/>
        </p>
        <p class="input-box">
          <span class="input-label">扶養家族</span>
          <input class="input input-modal" v-model="ocrInputDataRight.fuyo_kazoku"/>
        </p>
        <p class="input-box">
          <span class="input-label">配偶者有無</span>
          <input class="input input-modal" v-model="ocrInputDataRight.haigusha_umu"/>
        </p>
        <p class="input-box">
          <span class="input-label">配偶者扶養義務</span>
          <input class="input input-modal" v-model="ocrInputDataRight.haigusha_fuyo_gimu"/>
        </p>
        <p class="input-box">
          <span class="input-label">希望</span>
          <input class="input input-modal" v-model="ocrInputDataRight.kibo"/>
        </p>
        <!-- <p class="input-box" v-if="ocrData.data[1].kinmu_kaishi_kano_jiki">
          <span class="input-label">その他</span> -->
          <!-- <input class="input input-modal" v-model="ocrData.data[1].kinmu_kaishi_kano_jiki[0]"/> -->
          <!-- <input class="input input-modal" v-model="ocrData.data[1].kinmu_kaishi_kano_jiki[0]"/> -->
        <!-- </p> -->
      </div>
    </div>
    <div style="padding: 16px;">
      <b-field style="width: 100%">
        <div style="width: 20%; padding:8px; align: left">
          <!-- 前へ戻るボタン -->
          <button
            class="button"
            style="margin-right: 8px;"
            @click="preView"
            :disabled="rirekisyoStepNew == 0 || isLoadingResume"
          >
            ＜ 前へ戻る
          </button>
        </div>
        <div style="width: 20%; padding:8px; align: left">
          <!-- 次へ進むボタン -->
          <button
            class="button"
            style="margin-left: 8px;"
            @click="nextView"
            :disabled="rirekisyoStepNew == 4 || isLoadingResume"
          >
            ＞ 次へ進む
          </button>
        </div>
        <div style="width: 15%; padding:8px; align: left">
          <!-- 登録ボタン -->
          <button
            class="button is-primary"
            style="margin-left: 8px;"
            @click="editResume()"
            v-if="rirekisyoStepNew == 4 && !isLoadingResume"
          >
            登録する
          </button>
        </div>
        <div style="width: 15%; padding:8px; align: left">
          <!-- Wait表示 -->
          <button
            class="button is-primary"
            style="margin-left: 8px;"
            v-if="rirekisyoStepNew == 4 && isLoadingResume"
          >
            <span class="mdi mdi-loading mdi-spin"></span>
            しばらくお待ちください
          </button>
        </div>
      </b-field>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  name: 'Manage',
  componentName: 'Manage',
  mixins: [
    controlLogMixin
  ],
  props: {
    ocrData: {
      required: true,
    },
    seeker: {
      required: true,
    },
    fileLeft: {
      required: true,
    },
    fileRight: {
      required: true,
    },
    isDuplicateSeekerFlag: {
      type: Boolean,
      required: false,
      default: false,
    },
    isGetRoboTalk: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data () {
    return {
      ocrInputData: null,
      rirekisyoStepNew: 0,
      isLoadingResume: false,
      shikakuData: {
        'shikaku_nen': null,
        'shikaku_tsuki': null,
        'shikaku': null
      },
      keirekiData: {
        'reki_nen': null,
        'reki_tsuki': null,
        'reki': null
      },
      shikakuTable: [],
      keirekiTable: [],
      keirekiTable2: [],
      ocrInputDataLeft: null,
      ocrInputDataRight: null,
    }
  },
  computed: {
    ...mapState('auth', ['user']),
  },
  mounted () {
    this.ocrInputDataLeft  = {
      name_furigana : this.ocrData.data[0].name_furigana ? this.ocrData.data[0].name_furigana[0] : null,
      name          : this.ocrData.data[0].name ? this.ocrData.data[0].name[0] : null,
      sex           : this.ocrData.data[0].sex ? this.ocrData.data[0].sex[0] : null,
      birthday      : this.ocrData.data[0].birthday ? this.ocrData.data[0].birthday[0] : null,
      addr_furigana : this.ocrData.data[0].addr_furigana ? this.ocrData.data[0].addr_furigana[0] : null,
      addr          : this.ocrData.data[0].addr ? this.ocrData.data[0].addr[0] : null,
      tel           : this.ocrData.data[0].tel ? this.ocrData.data[0].tel[0] : null,
      email         : this.ocrData.data[0].email ? this.ocrData.data[0].email[0] : null,
      reki_nen      : this.ocrData.data[0].reki_nen ? this.ocrData.data[0].reki_nen : [],
      reki_tsuki    : this.ocrData.data[0].reki_tsuki ? this.ocrData.data[0].reki_tsuki : [],
      reki          : this.ocrData.data[0].reki ? this.ocrData.data[0].reki : [],
    }
    this.ocrInputDataRight = {
      reki_nen           : this.ocrData.data[1].reki_nen ? this.ocrData.data[1].reki_nen : null,
      reki_tsuki         : this.ocrData.data[1].reki_tsuki ? this.ocrData.data[1].reki_tsuki : null,
      reki               : this.ocrData.data[1].reki ? this.ocrData.data[1].reki : null,
      shikaku_nen        : this.ocrData.data[1].shikaku_nen ? this.ocrData.data[1].shikaku_nen : null,
      shikaku_tsuki      : this.ocrData.data[1].shikaku_tsuki ? this.ocrData.data[1].shikaku_tsuki : null,
      shikaku            : this.ocrData.data[1].shikaku ? this.ocrData.data[1].shikaku : null,
      tsukin_jikan       : this.ocrData.data[1].tsukin_jikan ? this.ocrData.data[1].tsukin_jikan[0] : null,
      moyori_eki         : this.ocrData.data[1].moyori_eki ? this.ocrData.data[1].moyori_eki[0] : null,
      fuyo_kazoku        : this.ocrData.data[1].fuyo_kazoku ? this.ocrData.data[1].fuyo_kazoku[0] : null,
      haigusha_umu       : this.ocrData.data[1].haigusha_umu ? this.ocrData.data[1].haigusha_umu[0] : null,
      haigusha_fuyo_gimu : this.ocrData.data[1].haigusha_fuyo_gimu ? this.ocrData.data[1].haigusha_fuyo_gimu[0] : null,
      shibo_doki         : this.ocrData.data[1].shibo_doki ? this.ocrData.data[1].shibo_doki[0] : null,
      kibo               : this.ocrData.data[1].kibo ? this.ocrData.data[1].kibo[0] : null,
    }
    //前後のスペースを削除
    for (let key of Object.keys(this.ocrInputDataLeft)) {
      if (typeof(this.ocrInputDataLeft[key]) == 'string') {
        this.ocrInputDataLeft[key] = this.ocrInputDataLeft[key].trim()
      }
    }
    for (let key of Object.keys(this.ocrInputDataRight)) {
      if (typeof(this.ocrInputDataRight[key]) == 'string') {
        this.ocrInputDataRight[key] = this.ocrInputDataRight[key].trim()
      }
    }
  },
  methods: {
    editResume () {
      //空欄のバリデーション
      let empty = ''
      if (!this.ocrInputDataLeft.name) empty += '「名前」'
      if (!this.ocrInputDataLeft.sex) empty += '「性別」'
      if (!this.ocrInputDataLeft.birthday) empty += '「誕生日」'
      if (!this.ocrInputDataLeft.addr) empty += '「住所」'
      if (!this.ocrInputDataLeft.tel) empty += '「TEL」'
      if (!this.ocrInputDataLeft.email) empty += '「Email」'
      if (empty !== '') {
        alert('必須項目'+empty+'が空欄です')
        return
      }

      // 登録内容のバリデーション
      // 文字列最大長チェック
      if (this.ocrInputDataLeft.name_furigana) {
        if (this.ocrInputDataLeft.name_furigana.length > 50) {
          alert('名前(ふりがな)は50文字以下で入力してください')
          return
        }
      }
      if (this.ocrInputDataLeft.name.length > 50) {
        alert('名前は50文字以下と想定されます')
        return
      }
      if (this.ocrInputDataLeft.sex.length > 15) {
        alert('性別は15文字以下で入力してください')
        return
      }
      if (this.ocrInputDataLeft.birthday.length > 50) {
        alert('誕生日は50文字以下で入力してください')
        return
      }
      if (this.ocrInputDataLeft.addr_furigana) {
        if (this.ocrInputDataLeft.addr_furigana.length > 200) {
          alert('住所(ふりがな)は200文字以下で入力してください')
          return
        }
      }
      if (this.ocrInputDataLeft.addr.length > 200) {
        alert('住所は200文字以下で入力してください')
        return
      }
      if (this.ocrInputDataLeft.tel.length > 20) {
        alert('電話番号は20文字以下で入力してください')
        return
      }
      if (this.ocrInputDataLeft.email.length > 254) {
        alert('メールアドレスは254文字以下で入力してください')
        return
      }
      if (this.ocrInputDataRight.fuyo_kazoku) {
        if (this.ocrInputDataRight.fuyo_kazoku > 50) {
          alert('扶養家族は50文字以内で入力してください')
          return
        }
      }
      if (!this.ocrInputDataRight.haigusha_umu) {
        alert('配偶者有無は「有」または「無」です')
        return
      }
      if (!this.ocrInputDataRight.haigusha_fuyo_gimu) {
        alert('配偶者扶養義務は「有」または「無」です')
        return
      }

      // フォーマットチェック
      if (this.ocrInputDataLeft.name_furigana) {
        if (!/^[ぁ-んァ-ンヴー 　]*$/.test(this.ocrInputDataLeft.name_furigana)) {
          alert('名前(ふりがな)に不正な文字が含まれています')
          return
        }
      }
      if (!(/^(令和|平成|昭和|西暦)?[0-9０-９]+年[0-9０-９]+月[0-9０-９]+日生?(\(満?[0-9０-９]+(才|歳)\))?$/.test(this.ocrInputDataLeft.birthday.replace(/( |　)/, '')) ||
      /^(R|H|S)?[0-9０-９]+\.[0-9０-９]+\.[0-9０-９]+$/.test(this.ocrInputDataLeft.birthday.replace(/( |　)/, '')) )) {
        alert('誕生日が不正な形式です')
        return
      }
      if (this.ocrInputDataLeft.addr_furigana) {
        if (!/^[ぁ-んァ-ンヴー　a-z A-Z0-9０-９]*$/.test(this.ocrInputDataLeft.addr_furigana)) {
          alert('住所(ふりがな)に不正な文字が含まれています')
          return
        }
      }
      if (!/^[0-9\-\+]+$/.test(this.ocrInputDataLeft.tel)) {
        alert('電話番号に不正な文字が含まれています')
        return
      }
      if (!/^[0-9a-zA-Z\.\-_]+@[0-9a-zA-Z\.\-_]+$/.test(this.ocrInputDataLeft.email)) {
        alert('メールアドレスが不正な形式です')
        return
      }
      if (this.ocrInputDataRight.fuyo_kazoku) {
        if (!/^[0-9０-９]+人?$/.test(this.ocrInputDataRight.fuyo_kazoku)) {
          alert('扶養家族は「○人」と想定されます')
          return
        }
      }
      if (this.ocrInputDataRight.haigusha_umu) {
        if (!/^(有|無)$/.test(this.ocrInputDataRight.haigusha_umu)) {
          alert('配偶者有無は「有」または「無」です')
          return
        }
      }
      if (this.ocrInputDataRight.haigusha_fuyo_gimu) {
        if (!/^(有|無)$/.test(this.ocrInputDataRight.haigusha_fuyo_gimu)) {
          alert('配偶者扶養義務は「有」または「無」です')
          return
        }
      }

      this.sendControlLog('履歴書登録', '応募者の登録モーダルから、新規応募者を履歴書登録した。')

      var keireki = []
      var shikaku = []
      // push
      for (let i in this.ocrInputDataLeft.reki_nen) {
        let pushData = {}
        if (this.ocrInputDataLeft.reki_nen[i] && this.ocrInputDataLeft.reki_tsuki[i] && this.ocrInputDataLeft.reki[i]) {
          pushData['reki_nen']   = this.ocrInputDataLeft.reki_nen[i]
          pushData['reki_tsuki'] = this.ocrInputDataLeft.reki_tsuki[i]
          pushData['reki']       = this.ocrInputDataLeft.reki[i]
          keireki.push(pushData)
        }
      }
      for (let i in this.ocrInputDataRight.reki_nen) {
        let pushData = {}
        if (this.ocrInputDataRight.reki_nen[i] && this.ocrInputDataRight.reki_tsuki[i] && this.ocrInputDataRight.reki[i]) {
          pushData['reki_nen']   = this.ocrInputDataRight.reki_nen[i]
          pushData['reki_tsuki'] = this.ocrInputDataRight.reki_tsuki[i]
          pushData['reki']       = this.ocrInputDataRight.reki[i]
          keireki.push(pushData)
        }
      }
      for (let i in this.keirekiTable) {
        let pushData = {}
        if (this.keirekiTable[i].reki_nen && this.keirekiTable[i].reki_tsuki && this.keirekiTable[i].reki) {
          pushData['reki_nen']   = this.keirekiTable[i].reki_nen
          pushData['reki_tsuki'] = this.keirekiTable[i].reki_tsuki
          pushData['reki']       = this.keirekiTable[i].reki
          keireki.push(pushData)
        }
      }
      for (let i in this.keirekiTable2) {
        let pushData = {}
        if (this.keirekiTable2[i].reki_nen && this.keirekiTable2[i].reki_tsuki && this.keirekiTable2[i].reki) {
          pushData['reki_nen']   = this.keirekiTable2[i].reki_nen
          pushData['reki_tsuki'] = this.keirekiTable2[i].reki_tsuki
          pushData['reki']       = this.keirekiTable2[i].reki
          keireki.push(pushData)
        }
      }
      for (let i in this.ocrInputDataRight.shikaku_nen) {
        let pushData = {}
        if (this.ocrInputDataRight.shikaku_nen[i].length && this.ocrInputDataRight.shikaku_tsuki[i] && this.ocrInputDataRight.shikaku[i]) {
          pushData['shikaku_nen']   = this.ocrInputDataRight.shikaku_nen[i]
          pushData['shikaku_tsuki'] = this.ocrInputDataRight.shikaku_tsuki[i]
          pushData['shikaku']       = this.ocrInputDataRight.shikaku[i]
          shikaku.push(pushData)
        }
      }
      for (let i in this.shikakuTable) {
        let pushData = {}
        if (this.shikakuTable[i].shikaku_nen && this.shikakuTable[i].shikaku_tsuki && this.shikakuTable[i].shikaku) {
          pushData['shikaku_nen']   = this.shikakuTable[i].shikaku_nen
          pushData['shikaku_tsuki'] = this.shikakuTable[i].shikaku_tsuki
          pushData['shikaku']       = this.shikakuTable[i].shikaku
          shikaku.push(pushData)
        }
      }
      if (this.seeker) {
        this.isLoadingResume = true
        // ここから反映作業
        for (let k of keireki) {
          let createCareer = {
            career_year:  k.reki_nen,
            career_month: k.reki_tsuki,
            career_body:  k.reki,
            seeker:       this.seeker.id,
          }
          this.$store.dispatch('directtalk/createCareer', createCareer)
        }
        for (let s of shikaku) {
          let createQualification = {
            qualification_year:  s.shikaku_nen,
            qualification_month: s.shikaku_tsuki,
            qualification_body:  s.shikaku,
            seeker: this.seeker.id,
          }
          this.$store.dispatch('directtalk/createQualification', createQualification)
        }
        let sexTemp = null
        if (this.ocrInputDataLeft.sex) {
          sexTemp = this.ocrInputDataLeft.sex.indexOf("男") >= 0 ? '1' : this.ocrInputDataLeft.sex.indexOf("女") >= 0 ? '2' : '0'
        }
        let updateSeeker = {
          id: this.seeker.id,
          name: this.ocrInputDataLeft.name ? this.ocrInputDataLeft.name : this.seeker.name,
          name_phonetic: this.ocrInputDataLeft.name_furigana,
          sex: sexTemp,
          address: this.ocrInputDataLeft.addr,
          tel: this.ocrInputDataLeft.tel,
          email: this.ocrInputDataLeft.email,
          requirement: this.ocrInputDataRight.kibo ? this.ocrInputDataRight.kibo : '',
          // 作成後のリロードで重複フラグが取得されるようにフラグを設定
          is_duplicate_seeker_flag: this.isDuplicateSeekerFlag,
          is_get_robo_talk: this.isGetRoboTalk
        }
        this.$store.dispatch('directtalk/updateSeeker', updateSeeker)
        let createFiles1 = new FormData()
        createFiles1.append('file', this.fileLeft)
        createFiles1.append('name', this.fileLeft.name)
        createFiles1.append('seeker', this.seeker.id)
        this.$store.dispatch('directtalk/createSeekerFiles', createFiles1)
        let createFiles2 = new FormData()
        createFiles2.append('file', this.fileRight)
        createFiles2.append('name', this.fileRight.name)
        createFiles2.append('seeker', this.seeker.id)
        this.$store.dispatch('directtalk/createSeekerFiles', createFiles2)
        setTimeout(() => {
          this.isLoadingResume = false
          alert('アップロード完了しました！')
          this.$emit('modalOff')
        }, 5000)
      } else {
        this.isLoadingResume = true
        let sexTemp = null
        if (this.ocrInputDataLeft.sex) {
          sexTemp = this.ocrInputDataLeft.sex.indexOf("男") >= 0 ? '1' : this.ocrInputDataLeft.sex.indexOf("女") >= 0 ? '2' : '0'
        }
        let createSeeker = {
          sessionid: '@2',
          is_subscribe: true,
          subscribe_date: new Date(),
          subscribe_count: 1,
          name: this.ocrInputDataLeft.name,
          name_phonetic: this.ocrInputDataLeft.name_furigana,
          group: this.user.companyID,
          sex: sexTemp,
          address: this.ocrInputDataLeft.addr,
          tel: this.ocrInputDataLeft.tel,
          email: this.ocrInputDataLeft.email,
          requirement: this.ocrInputDataRight.kibo ? this.ocrInputDataRight.kibo : '',
          // 作成後のリロードで重複フラグが取得されるようにフラグを設定
          is_duplicate_seeker_flag: this.isDuplicateSeekerFlag,
          is_get_robo_talk: this.isGetRoboTalk
        }
        this.$store.dispatch('directtalk/createSeeker', createSeeker)
          .then((d) => {
            let createFiles1 = new FormData()
            createFiles1.append('file', this.fileLeft)
            createFiles1.append('name', this.fileLeft.name)
            createFiles1.append('seeker', d.id)
            this.$store.dispatch('directtalk/createSeekerFiles', createFiles1)
            let createFiles2 = new FormData()
            createFiles2.append('file', this.fileRight)
            createFiles2.append('name', this.fileRight.name)
            createFiles2.append('seeker', d.id)
            this.$store.dispatch('directtalk/createSeekerFiles', createFiles2)
            // ここから反映作業
            for (let k of keireki) {
              let createCareer = {
                career_year:  k.reki_nen,
                career_month: k.reki_tsuki,
                career_body:  k.reki,
                seeker:       d.id,
              }
              this.$store.dispatch('directtalk/createCareer', createCareer)
            }
            for (let s of shikaku) {
              let createQualification = {
                qualification_year:  s.shikaku_nen,
                qualification_month: s.shikaku_tsuki,
                qualification_body:  s.shikaku,
                seeker: d.id,
              }
              this.$store.dispatch('directtalk/createQualification', createQualification)
            }
            setTimeout(() => {
              this.isLoadingResume = false
              alert('アップロード完了しました！')
              this.$emit('modalOff')
            }, 5000)
          })
          .catch((e) => {
            console.log('エラーが発生いたしました。')
          })
      }
    },
    nextView () {
      this.rirekisyoStepNew < 4 ? this.rirekisyoStepNew++ : this.rirekisyoStepNew=4
      let isRekiNen = Boolean(
        this.rirekisyoStepNew == 2 &&
        this.ocrInputDataRight.reki_nen[0] == '' &&
        this.ocrInputDataRight.reki_nen[1] == '' &&
        this.ocrInputDataRight.reki_nen[2] == '' &&
        this.ocrInputDataRight.reki_nen[3] == '')
      isRekiNen ? this.rirekisyoStepNew++ : this.rirekisyoStepNew = this.rirekisyoStepNew
    },
    preView () {
      this.rirekisyoStepNew > 0 ? this.rirekisyoStepNew-- : this.rirekisyoStepNew = 0
      let isRekiNen = Boolean(
        this.rirekisyoStepNew == 2 &&
        this.ocrInputDataRight.reki_nen[0] == '' &&
        this.ocrInputDataRight.reki_nen[1] == '' &&
        this.ocrInputDataRight.reki_nen[2] == '' &&
        this.ocrInputDataRight.reki_nen[3] == '')
      isRekiNen ? this.rirekisyoStepNew-- : this.rirekisyoStepNew = this.rirekisyoStepNew
    }
  }
}
</script>

<style scoped>
table td:not([align]), table th:not([align]) {
  text-align: center;
}
table {
  width: 100%;
  border-collapse:collapse;
  margin: 0 auto;
}
td,th {
  padding:10px;
  margin: auto;
  max-width: 350px;
  font-size: smaller;
}
td {
  text-align: left;
}
th {
  color:#fff;
  background:#AA0066;
}
table tr:nth-child(odd) {
  background:#ffeeff;
}
table tr:nth-child(even) {
  background:#fafafa;
}
.resume-table {
  //overflow-y: scroll;
  height: 410px;
}
.resume-table::-webkit-scrollbar {
  //width: 10px;
  //height: 10px;
  //visibility: hidden;
}
.recruit-table {
  display: block;
  height: calc(100vh - 200px);
  width: calc(100vw - 280px);
  overflow: scroll;
}
.recruit-table::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;
}
.container-manage {
  height: calc(100vh - 80px);
  width: calc(100% - 200px);
  overflow-y: scroll;
}
.container-manage::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;
}
.header-box {
  width: calc(100% - 80px);
  margin: 10px 40px;
  margin-bottom: 25px;
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: dotted 6px #323;
  flex-wrap: wrap;
}
.header-menu {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
}
.export-body::-webkit-scrollbar {
  width:  10px !important;
  height: 10px !important;
  visibility: visible !important;
}
.main-box {
  width: 100%;
  padding: 0;
}
.table-list {
  border: solid thin #ccc;
  height: calc(100vh - 180px);
  overflow: scroll;
}
.export-box {
  height: calc(100vh - 130px);
  width: 100%;
}
.export-body {
  height: calc(100vh - 187px);
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  display: -webkit-inline-box;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.export-body::-webkit-scrollbar {
  width:  0px !important;
  height: 10px !important;
  visibility: visible !important;
  background: white;
}
.export-list {
  margin: 20px;
  margin-right: 5px;
  margin-left:  10px;
  height: calc(100% - 40px);
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background: rgba(200, 200, 200, 0.5);
  border-radius: 10px;
}
.export-list-header {
  background: rgba(0, 0, 0, 0.7);
  border-radius: 10px;
  width: 200px;
  height: 40px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  color: white;
  font-size: 16px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.export-list-body {
  border-radius: 10px;
  width: 190px;
  text-align: center;
  color: black;
  font-size: 16px;
  margin: 5px;
  margin-bottom: 0;
  padding: 10px;
  background: white;
  min-height: 44px;
}
.export-header {
  height: 50px;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.add-box {
  margin: 20px;
  margin-left: 5px;
  margin-right: 10px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  /* padding: 20px; */
  width: 210px;
  height: 40px;
}
.date-box {
  width: 40%;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  justify-content: space-between
}
.option-box {
  width: 60%;
  padding-right: 10px; 
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 5px;
  overflow: scroll;
}
.resume-btn {
  border-radius: 50%;
  height: 36px;
  width: 36px;
  font-size: 16px;
}

.wrapper-cover-img {
  position: relative;
}

.input-box {
  text-align: left;
  width: 100%;
  display: flex;
  border-bottom: solid thin #ccc !important;
  border-right: solid thin #ccc !important;
  border-left: solid thin #ccc !important;
}
.input-label {
  width: 30%;
  border-right: solid thin #ccc !important;
  background: rgba(250, 230, 230) !important;
  padding: 8px !important;
}
.input-modal {
  width: calc(100% - 30%);
  height: 40px;
  color: #222 !important;
  font-size: 16px !important;
  background: #f8f8f8 !important;
  padding: 8px !important;
  border-radius: 0;
  border: none;
  box-shadow: none;
}

.table-box {
  width: 100%;
}
.table-box-header {
  border: solid thin #ccc !important;
  background: rgb(250, 230, 230) !important;
  color: #222;
  padding: 8px !important;
}
.input-table {
  height: 40px;
  color: #222 !important;
  font-size: 16px;
  background: #f8f8f8 !important;
  padding: 8px !important;
  border-radius: 0;
  box-shadow: none !important;
}
.container-birth{
  display: flex
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Manage/ResumeTable.vue